import React, { useState, useEffect } from 'react';

const CookieConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleConsent = (consent: boolean) => {
    localStorage.setItem('cookie_consent', consent ? 'accepted' : 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-50">
      <div className="flex flex-col md:flex-row items-center justify-between p-6 bg-mp-surface text-mp-text border border-mp-border shadow-lg">
        <div className="text-sm text-mp-muted font-body mb-4 md:mb-0 md:mr-6">
          We use cookies to enhance your experience and analyze traffic.
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => handleConsent(false)}
            className="px-4 py-2 text-xs font-mono bg-mp-bg border border-mp-border text-mp-muted hover:text-mp-text hover:border-mp-muted transition-colors uppercase tracking-wider"
          >
            Decline
          </button>
          <button
            onClick={() => handleConsent(true)}
            className="px-4 py-2 text-xs font-mono bg-primary text-mp-text hover:bg-primary-hover transition-colors uppercase tracking-wider"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
